import { KeyboardEvent } from 'react';

export const onInputKeyDown = (event: KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>, callback: () => void) => {
  if (event.key === 'Enter' && !event.shiftKey) {
    event.preventDefault();
    callback();
  }
};

export const replaceCommaWithPeriod = (value: any) => {
  return value ? value.toString().replace(/,/g, '.') : '';
};
